import { ConfigProvider, notification } from "antd";
import locale from "antd/lib/locale/fr_FR";
import { killAllTeacherInsta } from "api/services/advertissements/advertissements.services";
import { FLAGS, StatusCode, UserRoles } from "common/enums";
import { AppDrawer } from "components/Drawer";
import Footer from "components/footer";
import { Header } from "components/header";
import { InformationsPaiement } from "components/informationsPaiement";
import AppButton from "components/libs/button";
import AppChat from "components/messagerieV1";
import { DrawerPaiementComponent } from "components/paiement";
import { ProfileDetailsDrawer } from "components/profileDetailsDrawer";
import DrawerReport from "components/reportDrawer";
import UserConnect from "components/userConnect";
import "moment/locale/fr";
import { FC, Suspense, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { useIdleTimer } from "react-idle-timer";
import { useDispatch, useSelector } from "react-redux";
import AppRoutes from "routes";
import DrawerAds from "screens/teacher/TeacherAds/components";
import WizardTeacher from "screens/teacher/components/wizard";
import io from "socket.io-client";
import {
  initSocket,
  setChatReceiverId,
  setSelectUserChat,
  toggleAppChat
} from "store/AppChat/appChat";
import { useFindRoomMutation, useGetAllRoomsQuery } from "store/services/chat";
import "./App.less";
import "./global/globals.css";

//!ASSETS
import { CloseOutlined } from "@ant-design/icons";
import { getUserByUid } from "api/services/auth/auth.services";
import AlbertHappy from "assets/images/albert/status/Happy.svg";
import AlbertNeutre from "assets/images/albert/status/Neutre.svg";
import AlbertSad from "assets/images/albert/status/Sad.svg";
import AlbertVeryHappy from "assets/images/albert/status/Very happy.svg";

import { API_RESSOURCES } from "api/services/teacher/teacher.routes";
import axios, { AxiosResponse } from "axios";
import AlbertBotAI from "components/albertAI";
import { getMaintenanceStatus } from "config/firebase.config";
import { useLocation, useNavigate } from "react-router-dom";
import CouponsDrawer from "screens/teacher/components/coupons";
import { setUserHavingCalendar } from "store/app/appSlice";
import { setIsAppInMaintenance, updateUser } from "store/auth/authSlice";

import { skipToken } from "@reduxjs/toolkit/query";

interface CustomResponse {
  statusCode: number;
  message: string;
  data: any;
}

const App: FC = () => {
  const { user, isLoggedIn } = useSelector((s) => s.auth);
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const { refetch } = useGetAllRoomsQuery(
    user?._id ?? skipToken
  );
  /* const { openAppChat } = useSelector((state) => state.appChat); */
  const [findRoom, { isSuccess }] = useFindRoomMutation();
  const navigate = useNavigate();

  const location = useLocation();
  const path = location.pathname;

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1051);
  const handleResize = () => {
    setIsMobile(window.innerWidth < 1051);
  };
  window.addEventListener('resize', handleResize);

  const API_SOCKET = process.env.REACT_APP_API_SOCKET;
  const socket = useRef<any>(
    io(`${API_SOCKET}`, {
      reconnectionAttempts: 1,
      reconnectionDelay: 500,
      autoConnect: false,
      multiplex: false,
    })
  );

  const originalWarn = console.warn;
  console.warn = function (message, ...args) {
    if (!message.includes('This CKEditor 4.17.1 version is not secure')) {
      originalWarn.apply(console, [message, ...args]);
    }
  };

  const handleOnIdle = async (event?: any) => {
    if (isLoggedIn) {
      await socket?.current.emit("unsubscribe", user?._id);
      await socket.current?.emit("subscribe", user?._id);
    }
  };

  const handleOnActive = async (event: any) => {
    if (isLoggedIn) {
      await socket?.current.emit("unsubscribe", user?._id);
      await socket.current?.emit("subscribe", user?._id);
    }
  };

  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: 1000 * 60 * 1,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    // onAction: handleOnAction,
    debounce: 500,
  });

  //!FUNCTIONS
  const handleDisplayUserChat = (idUser: string) => {
    const finalData = {
      actor1: user?._id,
      actor2: idUser,
      flag: FLAGS.SINGLE_FLAG,
      type: "",
      instaprof: "",
    };

    findRoom(finalData);
    dispatch(setChatReceiverId(idUser));
  };

  const updateUserData = async () => {
    const getInfosResponse = await getUserByUid(user?.uid);
    if (getInfosResponse?.statusCode === StatusCode.OK) {
      dispatch(updateUser(getInfosResponse?.data));
    }
  }

  const checkTeacherCalender = async () => {
    const startDate = new Date().toISOString().split("T")[0];
    try {
      const response: AxiosResponse<CustomResponse> = await axios.get(`${API_RESSOURCES}/advertisements/fetch/ReelCalender/prof/instance/${user?._id}`, {
        params: { startDate },
      });
      if (response.status === StatusCode.OK) {
        if (response?.data?.data) {
          dispatch(setUserHavingCalendar(true));
        }
        else {
          dispatch(setUserHavingCalendar(false));
        }
      }
      else {
        dispatch(setUserHavingCalendar(false));
      }

    } catch (error) {
      dispatch(setUserHavingCalendar(false));
    }
  };

  const shouldHideFooter = [
    "mon-contenu",
    "chapters",
    "courses",
    "search/quizz",
    "exercices",
    "view/chapter",
    "view/quizz",
    "view/exercice"
  ].some((part) => path.includes(part));

  useEffect(() => {
    if (isLoggedIn) {
      if (user?.roles?.includes(UserRoles.TEACHER)) {
        checkTeacherCalender();
      }
    }
  }, [isLoggedIn, user]);

  useEffect(() => {
    if (isLoggedIn) {
      if (window.performance) {
        if (performance.navigation.type == 1) {
          localStorage.setItem("instaProfLength", "0");
          localStorage.setItem("reload", "true");

          const handleKill = async () => {
            if (user?._id) {
              await socket?.current.emit("unsubscribe", user?._id);
              await socket.current?.emit("subscribe", user?._id);
            }

            if (localStorage.getItem("studentTempCodeInstaProf")) {
              await socket?.current.emit(
                "killRequestInstaProf",
                localStorage.getItem("studentTempCodeInstaProf")
              );

              await killAllTeacherInsta(
                user?._id,
                localStorage.getItem("studentTempCodeInstaProf") || ""
              );
              localStorage.removeItem("studentTempCodeInstaProf");
            }
          };
          handleKill();
        }
      }
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (isLoggedIn) {
      socket?.current.connect();
      dispatch(initSocket(socket.current));
    }
  }, [dispatch, isLoggedIn]);

  useEffect(() => {
    if (isLoggedIn) {
      socket?.current?.on(
        "receivedNewNotification",
        async (newMessage: any) => {
          refetch();
          /* updateUserData(); */
          /* dispatch(setIsNewData(true)); */
          if (newMessage?.notifType) {
            if (newMessage?.notifType === "popup") {
              notification.open({
                message: null,
                description: (
                  <div className="custom-notification-content">
                    <div className="custom-notification-avatar">
                      {newMessage?.albertHead === "AlbertSad" ? (
                        <img src={AlbertSad} alt="Albert" width={40} />
                      ) : newMessage?.albertHead === "AlbertNeutre" ? (
                        <img src={AlbertNeutre} alt="Albert" width={40} />
                      ) : newMessage?.albertHead === "AlbertHappy" ? (
                        <img src={AlbertHappy} alt="Albert" width={40} />
                      ) : newMessage?.albertHead === "AlbertVeryHappy" ? (
                        <img src={AlbertVeryHappy} alt="Albert" width={40} />
                      ) : (
                        <img src={AlbertNeutre} alt="Albert" width={40} />
                      )}
                    </div>
                    <div className="custom-notification-text" dangerouslySetInnerHTML={{ __html: newMessage?.content }} />
                  </div>
                ),
                className: "custom-notification",
                closeIcon: <CloseOutlined style={{ color: "#000" }} />,
                placement: "bottomRight",
                duration: 60,
              });
            }
            else {
              notification.open({
                message: <span style={{ color: "#000" }}>{newMessage?.title}</span>,
                description: (
                  <div>
                    <div dangerouslySetInnerHTML={{ __html: newMessage?.content }} />
                    {newMessage?.type === "messagerie" && (
                      <AppButton
                        onClick={() => {
                          handleDisplayUserChat(newMessage?.data?.senderId);
                        }}
                      >
                        Ouvrir la discussion
                      </AppButton>
                    )}
                  </div>
                ),
                icon:
                  newMessage?.albertHead === "AlbertSad" ? (
                    <div className="notificationImageBox"><img src={AlbertSad} alt="" height={30} /></div>
                  ) : newMessage?.albertHead === "AlbertNeutre" ? (
                    <div className="notificationImageBox"><img src={AlbertNeutre} alt="" height={30} /></div>
                  ) : newMessage?.albertHead === "AlbertHappy" ? (
                    <div className="notificationImageBox"><img src={AlbertHappy} alt="" height={30} /></div>
                  ) : newMessage?.albertHead === "AlbertVeryHappy" ? (
                    <div className="notificationImageBox"><img src={AlbertVeryHappy} alt="" height={30} /></div>
                  ) : (
                    <div className="notificationImageBox"><img src={AlbertNeutre} alt="Albert" height={30} /></div>
                  ),
                style: { background: "#FFF", color: "#000", fontSize: "15px" },
                duration: 60,
              });
            }
          }
          else {
            notification.open({
              message: <span style={{ color: "#000" }}>{newMessage?.title}</span>,
              description: (
                <div>
                  <div dangerouslySetInnerHTML={{ __html: newMessage?.content }} />
                  {newMessage?.type === "messagerie" && (
                    <AppButton
                      onClick={() => {
                        handleDisplayUserChat(newMessage?.data?.senderId);
                      }}
                    >
                      Ouvrir la discussion
                    </AppButton>
                  )}
                </div>
              ),
              icon: <div className="notificationImageBox"><img src={AlbertNeutre} alt="Albert" height={30} /></div>,
              style: { background: "#FFF", color: "#000", fontSize: "15px" },
              duration: 60,
            });
          }
        }
      );
    }
  }, []);

  useEffect(() => {
    if (isSuccess) {
      dispatch(setSelectUserChat(true));
      dispatch(toggleAppChat(true));
    }
  }, [isSuccess]);

  useEffect(() => {
    const handleSocket = async () => {
      if (user?._id) {
        await socket?.current.emit("unsubscribe", user?._id);
        await socket.current?.emit("subscribe", user?._id);
      }
    };

    handleSocket();
  }, [user?._id]);

  useEffect(() => {
    const isLoggedIn = auth.isLoggedIn;
    const searchParams = new URLSearchParams(location.search);
    if (searchParams !== undefined) {
      const token = searchParams.get('token');
      if (token !== null) {
        if (!isLoggedIn) {
          localStorage.setItem("affiliateToken", token);
        }
      }
    }
  }, [auth.isLoggedIn, location.search]);

  useEffect(() => {
    const isLoggedIn = auth.isLoggedIn;
    const searchParams = new URLSearchParams(location.search);
    if (searchParams !== undefined) {
      const classCode = searchParams.get('classCode');
      if (classCode !== null) {
        if (!isLoggedIn) {
          localStorage.setItem("classCode", classCode);
        }
      }
    }
  }, [auth.isLoggedIn, location.search]);

  useEffect(() => {
    const isLoggedIn = auth.isLoggedIn;
    const searchParams = new URLSearchParams(location.search);
    if (searchParams !== undefined) {
      const organismToken = searchParams.get('organisme_token');
      const organismClassCode = searchParams.get('access_code');
      const userType = searchParams.get('userType');
      if (organismToken !== null && organismClassCode !== null && userType !== null) {
        if (!isLoggedIn) {
          localStorage.setItem("organismToken", organismToken);
          localStorage.setItem("organismClassCode", organismClassCode);
          localStorage.setItem("userType", userType);
        }
      }
    }
  }, [auth.isLoggedIn, location.search]);

  useEffect(() => {
    const isLoggedIn = auth.isLoggedIn;
    const searchParams = new URLSearchParams(location.search);
    if (searchParams !== undefined) {
      const collectiveToken = searchParams.get('collective_token');
      const sessionId = searchParams.get('session_id');
      const classeId = searchParams.get('classe_id');
      if (collectiveToken !== null && sessionId !== null && classeId !== null) {
        if (!isLoggedIn) {
          localStorage.setItem("collectiveToken", collectiveToken);
          localStorage.setItem("sessionId", sessionId);
          localStorage.setItem("classeId", classeId);
        }
      }
    }
  }, [auth.isLoggedIn, location.search]);

  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      getMaintenanceStatus().then((isMaintenance: boolean) => {
        if (isMaintenance) {
          dispatch(setIsAppInMaintenance(true));
        }
        else {
          dispatch(setIsAppInMaintenance(false));
        }
      });
    }
  }, []);

  return (
    <>
      <Helmet>
        {/* {user?.roles?.includes(UserRoles?.TEACHER) && (
          <meta name="viewport" content="width=1440, initial-scale=.1" />
        )} */}
      </Helmet>
      <Suspense fallback={<p>Loading...</p>}>
        <ConfigProvider locale={locale}>
          <div className="app">
            <div>
              <DrawerReport />
              <Header />
              <InformationsPaiement />
              <WizardTeacher />
              <UserConnect />
              <AppRoutes />
              <AppDrawer />
              <AppChat />
              <ProfileDetailsDrawer />
              <CouponsDrawer />
              <DrawerPaiementComponent />
              {/* <MAA /> */}
              {/* <AideComponent envoyerNumeroHandler={null} /> */}
              <DrawerAds />
              {/* <DrawerUpdate /> */}
              {/* <AideComponent /> */}
            </div>

            {user?.roles[0]?.includes("student") && <AlbertBotAI />}

            {!shouldHideFooter && (
              <div
                className={`${user?.roles.includes(UserRoles.STUDENT) && "footerDisplay"
                  }`}
              >
                <Footer />
              </div>
            )}

            {user?.roles.includes(UserRoles.STUDENT) && (
              <div style={{ minHeight: "100px" }} className="fakeDiv" />
            )}
          </div>
        </ConfigProvider>
      </Suspense>
    </>
  );
};
export default App;
